// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";

export const getIsAuthenticated = (state: ApplicationState) => {
    return getSession(state).isAuthenticated;
};
export const getIsSignedIn = (state: ApplicationState) => {
    const session = getSession(state);
    const isAuthenticated = getIsAuthenticated(state);

    return session && (isAuthenticated || session.rememberMe) && !session.isGuest;
};
